var exports = {
  "i": "xaee3c4fa--55fa9d--wrapper",
};

module.exports = exports;
